import * as React from 'react';
import { colors } from '../../../index';

const IconCircleThree = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 21 21",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    fill: "#FCFCFC",
    opacity: 0.147,
    cx: 10.5,
    cy: 10.5,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.902 10.01h.678c.426-.007.761-.119 1.005-.337.244-.218.366-.512.366-.883 0-.832-.414-1.248-1.244-1.248-.39 0-.701.111-.934.334-.232.223-.349.518-.349.885h-.902c0-.562.206-1.03.617-1.402.411-.373.934-.559 1.568-.559.67 0 1.195.177 1.576.532.38.354.57.847.57 1.478 0 .309-.1.608-.3.897-.2.29-.472.506-.817.65.39.123.692.328.905.614.213.286.32.636.32 1.049 0 .637-.208 1.143-.625 1.517-.416.374-.957.56-1.624.56-.667 0-1.209-.18-1.627-.54-.418-.362-.626-.838-.626-1.43h.907c0 .374.122.673.366.897.244.225.57.337.98.337.436 0 .77-.114 1-.341.231-.228.346-.555.346-.98 0-.414-.126-.731-.38-.952-.254-.221-.62-.335-1.098-.342h-.678v-.736z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

export default IconCircleThree;